__webpack_require__.p = "/wp-content/themes/global-gutenberg-theme/static/";